import { styled } from 'baseui'
import { FlexColumn, FlexCenterY } from '@/shared/theme/styled-components'

export const BoardPageWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  width: '100%',
})

export const FieldsColumn = styled(FlexColumn, {
  gap: '0.3125rem',
  marginBottom: '0.125rem',
})

export const ActionsRow = styled(FlexCenterY, {
  marginTop: '0.625rem',
})
